import{mdiFilter as t}from"@mdi/js";import r from"react";import{MdIcon as e}from"./MdIcon.js";const i=({id:i="filter",title:o="Filter",...m})=>r.createElement(e,{id:i,title:o,path:t,...m});export{i as FilterIcon};
